import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "relative cursor-auto" }
const _hoisted_2 = {
  key: 0,
  class: "bg-blue-primary rounded-md"
}
const _hoisted_3 = { class: "text-center p-3" }
const _hoisted_4 = { class: "text-center text-white text-sm" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Update token image.  ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Add Image ")
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "form-group mb-4 text-center mt-5" }
const _hoisted_10 = { class: "form-group mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm mb-2 text-white" }, "Token Name", -1)
const _hoisted_12 = { class: "form-group mb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm mb-2 text-white" }, "Token Symbol", -1)
const _hoisted_14 = { class: "form-group mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm mb-2 text-white" }, "Type of Token", -1)
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "text-center mb-5 mt-3" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 2,
  class: "text-center w-full"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "items-center mt-4 flex" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "animate-spin h-3 w-3 mr-3 bg-yellow-500 inline-block",
      viewBox: "0 0 24 24"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-sm" }, "Creating token. Please wait..")
  ])
], -1)
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_tokensConfirmCreateTokenModal = _resolveComponent("tokensConfirmCreateTokenModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isDisplayUploadTokenImageLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fileInput.click())),
                class: "border border-blue-900 p-1 px-2 bg-blue-900 hover:bg-blue-800 transition-all duration-200 rounded-md"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-camera",
                  class: "text-white inline-block mr-2"
                }),
                _hoisted_6
              ]),
              _createElementVNode("input", {
                style: {"display":"none"},
                ref: "fileInput",
                type: "file",
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
                accept: ".png, .jpg, .jpeg"
              }, null, 544),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateTokenImage && _ctx.updateTokenImage(...args))),
                  disabled: !_ctx.fileInput,
                  class: "mr-3 bg-success-check disabled:bg-gray-600 text-white p-1 px-2 hover:bg-green-700 duration-200 transition-all rounded-md"
                }, "Confirm", 8, _hoisted_8),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.revertTokenImage && _ctx.revertTokenImage(...args))),
                  class: "hover:underline"
                }, "Cancel")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isDisplayUploadTokenImageLabel)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "absolute right-2 top-2 hover:bg-gray-700 w-8 h-8 items-center rounded-md text-sm",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('closeForm')), ["stop"]))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-close",
            class: "text-gray-text p-0 text-end inline-block text-sm"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        class: "inline-block border-black-border relative border border-dotted rounded-3xl w-36 bottom-0 h-36 left-0 bg-cover bg-center bg-black-body",
        style: _normalizeStyle({ 'background-image': `url(${_ctx.previewImage})` })
      }, [
        _createElementVNode("button", {
          class: "bg-black-body p-2 rounded-lg absolute",
          style: {"bottom":"0px","left":"0"},
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isDisplayUploadTokenImageLabel = !_ctx.isDisplayUploadTokenImageLabel))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-camera",
            class: "text-gray-text text-xl"
          })
        ])
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control outline-none px-3 py-2 rounded-md text-white border-0 w-full bg-black-body",
        placeholder: "Token Name",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tokenName) = $event))
      }, null, 512), [
        [_vModelText, _ctx.tokenName]
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        maxlength: "5",
        oninput: "this.value = this.value.toUpperCase()",
        class: "form-control outline-none px-3 py-2 rounded-md text-white border-0 w-full bg-black-body uppercase",
        placeholder: "Token Symbol",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tokenSymbol) = $event))
      }, null, 512), [
        [_vModelText, _ctx.tokenSymbol]
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _withDirectives(_createElementVNode("select", {
        class: "text-white px-2 py-2 border-0 rounded-md bg-black-body text-md w-full outline-none my-1",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedTokenType) = $event))
      }, [
        _createElementVNode("option", {
          value: "IGT",
          disabled: _ctx.divisibility > 6
        }, "In-Game Token", 8, _hoisted_16),
        _createElementVNode("option", {
          value: "LET",
          disabled: _ctx.divisibility != 0
        }, "Limited Edition Token", 8, _hoisted_17),
        _createElementVNode("option", {
          value: "NFT",
          disabled: _ctx.supply != 1
        }, "Non-Fungible Token", 8, _hoisted_18)
      ], 512), [
        [_vModelSelect, _ctx.selectedTokenType]
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("button", {
        disabled: _ctx.disableCreate,
        class: "btn btn-primary",
        onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.importToken && _ctx.importToken(...args)), ["stop"]))
      }, "Import Token", 8, _hoisted_20)
    ]),
    (_ctx.showUploadingLoader && _ctx.isXarcadeExist)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
      : _createCommentVNode("", true),
    _createVNode(_component_tokensConfirmCreateTokenModal, {
      networkLabel: _ctx.network,
      onCloseModel: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isQRModalShow = false)),
      onConfirmedButtonPressed: _cache[11] || (_cache[11] = ($event: any) => (_ctx.linkToken())),
      isQRModalShow: _ctx.isQRModalShow,
      previewImage: _ctx.previewImage,
      tokenName: _ctx.tokenName,
      tokenSymbol: _ctx.tokenSymbol,
      selectedTokenType: _ctx.selectedTokenType,
      supply: parseFloat(_ctx.supply),
      qr: _ctx.qr,
      showUploadingLoader: _ctx.showUploadingLoader,
      isDisabledModalConfirmSubmitButton: _ctx.isDisabledModalConfirmSubmitButton
    }, null, 8, ["networkLabel", "isQRModalShow", "previewImage", "tokenName", "tokenSymbol", "selectedTokenType", "supply", "qr", "showUploadingLoader", "isDisabledModalConfirmSubmitButton"])
  ]))
}